<template lang="html">
  <div class="capsule-builder-container" v-if="currentCapsule">
    <div class="capsule-builder-header">
      <h1 class="page-title">Capsule Builder</h1>
    </div>

    <TitleBar />
    <AddCustomeReferralUrlModal />
    <RemoveProductModal />
    <AddProductModal v-if="!capsulePublished" />
    <OutfitsModal :capsule="currentCapsule" />
    <PublishCapsuleModal v-if="!capsulePublished && capsulePublishable" />

    <div class="builder-stack-group">
      <StackItem
        v-for="layer in currentCapsule.layers"
        :capsule-published="capsulePublished"
        :layer="layer"
        :layer-group-info="layerGroupInfo(layer.slug)"
        :key="layer.id"
      />
    </div>

    <div class="preview-btn-wrapper">
      <b-button
        size="lg"
        variant="outline-unstitched"
        class="preview-capsule-btn mb-3 pr-5 pl-5"
        :disabled="!capsuleHasProducts"
        v-b-modal.preview-capsule
      >
        Preview capsule
      </b-button>
      <div class="preview-helper-text" v-show="!capsuleHasProducts">
        <small>Add products to preview capsule</small>
      </div>
    </div>

    <LayerGroup
      v-for="layer in currentCapsule.layers"
      :layer="layer"
      :key="layer.id"
    />
  </div>
</template>

<script>
// Modals
import AddCustomeReferralUrlModal from "@/components/capsuleBuilder/modals/AddCustomReferralUrlModal";
import AddProductModal from "@/components/capsuleBuilder/modals/AddProductModal";
import OutfitsModal from "@/components/capsuleBuilder/modals/OutfitsModal";
import PublishCapsuleModal from "@/components/capsuleBuilder/modals/PublishCapsuleModal";
import RemoveProductModal from "@/components/capsuleBuilder/modals/RemoveProductModal";

// UI Components
import LayerGroup from "@/components/capsuleBuilder/LayerGroup";
import StackItem from "@/components/capsuleBuilder/StackItem";
import TitleBar from "@/components/capsuleBuilder/TitleBar";

// Other
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    AddProductModal,
    AddCustomeReferralUrlModal,
    LayerGroup,
    OutfitsModal,
    PublishCapsuleModal,
    RemoveProductModal,
    StackItem,
    TitleBar,
  },

  data() {
    return {};
  },

  mounted() {
    window.analytics.page("Capsule Builder");

    this.fetchCurrentCapsule({
      capsuleId: this.$route.params.capsuleId,
      withLayerProducts: true,
    }).then(() => {
      this.checkCurrentCapsulePendingProducts();
    });

    if (this.hasPendingProducts) {
      this.pollData();
    }
  },

  beforeDestroy() {
    this.resetCurrentCapsule();
  },

  computed: {
    ...mapGetters(["currentCapsule", "capsuleLayerProductIdsPending"]),

    capsulePublishable() {
      return this.currentCapsule.publishable;
    },

    capsulePublished() {
      return this.currentCapsule.status == "published";
    },

    hasPendingProducts() {
      return this.numberOfPendingProducts > 0;
    },

    numberOfPendingProducts() {
      return this.capsuleLayerProductIdsPending.length;
    },

    capsuleHasProducts() {
      return this.currentCapsule.products_count > 0;
    },
  },

  methods: {
    ...mapActions([
      "fetchCurrentCapsule",
      "resetCurrentCapsule",
      "pollPendingCapsuleProducts",
      "checkCurrentCapsulePendingProducts",
    ]),

    layerGroupInfo(slug) {
      return this.$constants.LAYER_GROUPS.findRecursive(
        (x) => x.slug == slug,
        "subGroups"
      );
    },

    pollData() {
      this.pollPendingCapsuleProducts(this.currentCapsule.id).then(() => {
        if (this.hasPendingProducts) setTimeout(() => this.pollData(), 3000);
      });
    },
  },

  watch: {
    hasPendingProducts: function (newVal, oldVal) {
      if (newVal === true) this.pollData();
    },

    numberOfPendingProducts: function (newVal, oldVal) {
      if (newVal < oldVal) {
        bus.$emit(
          "makeToast",
          "Success! 🎉",
          `You've added a new product`,
          "success"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.capsule-builder-container {
  .capsule-builder-header {
    display: flex;
    justify-content: space-between;

    .publish-capsule-btn {
      border-radius: 0;
      padding: 15px;
      font-size: 11px;
      letter-spacing: 1.4px;

      &:hover {
        box-shadow: 0 8px 24px rgba($primary-blue, 0.25);
      }
    }
  }
}

.preview-btn-wrapper {
  text-align: center;
  margin-bottom: 40px;

  .preview-capsule-btn {
    text-transform: capitalize;
    border-width: 2px;
    border-color: $primary-accent;
    border-radius: 2rem;
    padding: 10px 45px 10px 45px;
  }

  .preview-helper-text {
    margin-top: -10px;
    color: $alizarin;
  }
}

.builder-stack-group {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  text-align: center;
  overflow-x: scroll;
  max-width: 100%;
  margin-top: 90px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/CapsuleBuilder.vue